import React from "react";
import _ from "lodash";
import Order from "../Order";
import Styles from "./PastOrders.styles";
import { useAppSelector } from "../../redux/hook";
import { Box, Typography } from "@mui/material";
export default function PastOrders({ orders }) {
  const { orders: currentOrders } = useAppSelector(
    (state) => state.orderReducer
  );
  const displayOrders = _.orderBy(
    orders,
    (order: any) => new Date(order.date).getTime(),
    ["desc"]
  );
  return _.isEmpty(displayOrders) ? (
    <div className="text-center">
      <Typography variant='body1'>
        {_.isEmpty(currentOrders)
          ? "Vous n'avez encore jamais passé de commande."
          : "Vous n'avez pas encore de commande finalisée."}
      </Typography>
    </div>
  ) : (
    <Box sx={Styles.container}>
      {_.map(displayOrders, (order) => {
        return <Order order={order} key={order.chargeId} showFees showPromo />;
      })}
    </Box>
  );
}
